<template>
    <div>
        <button class="btn-search"  @click="showSearchBox()">
            <searchIcone />
        </button>
        <Teleport to="body">
            <Transition  name="show-search-modal">
                <SearchBoxContent v-if="searchFlag" @setFlage="setFlage"/>
            </Transition>
           
        </Teleport>
       
    </div>
</template>

<script>
import searchIcone from '../icons/search.vue';

import Teleport from 'vue2-teleport';
import SearchBoxContent from '../../components/searchBox/content.vue';

export default {
    components:{SearchBoxContent,Teleport,searchIcone},
    data(){
        return{
            searchFlag:false
        }
    },
    methods:{
        showSearchBox(){
            this.searchFlag=true
        },
        setFlage(){
            
            this.searchFlag=false
        }
    }
}
</script>
<style scoped>
.btn-search{
    all: unset;
}
.show-search-modal-enter-active {
    animation: show-register 0.45s ease;
  }
  .show-search-modal-leave-active {
    animation: show-register 0.35s ease reverse;
  }
  @keyframes show-register {
    from {
      opacity: 0;
    }
    to {
      opacity: 1
    }
  }
</style>